import { compose, createStore } from 'redux';
import { createTrackerStoreEnhancer } from '@csod/tracker';
export * from '@csod/tracker';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ident = function ident(state) {
  return state;
};

var TrackerWithStore = // static store reference
function TrackerWithStore(trackerOptions, storeOptions) {
  var middlewareSettings = trackerOptions.middlewareSettings,
      API = trackerOptions.API,
      getAPIOptions = trackerOptions.getAPIOptions;
  var trackerStoreEnhancer = createTrackerStoreEnhancer(middlewareSettings, API, getAPIOptions);
  var enhancer = trackerStoreEnhancer,
      reducer = ident;

  if (storeOptions) {
    var _enhancers = storeOptions.enhancers,
        _rootReducer = storeOptions.rootReducer;

    if (_enhancers) {
      enhancer = compose.apply(void 0, [trackerStoreEnhancer].concat(_enhancers));
    }

    if (_rootReducer) {
      reducer = _rootReducer;
    }
  }

  TrackerWithStore.store = createStore(reducer, {}, enhancer);
};

_defineProperty(TrackerWithStore, "store", void 0);

_defineProperty(TrackerWithStore, "getState", function () {
  var store = TrackerWithStore.store;
  return store && store.getState();
});

_defineProperty(TrackerWithStore, "dispatch", function (action) {
  var store = TrackerWithStore.store;
  if (store) store.dispatch(action);
});

export { TrackerWithStore };



//////////////////
// WEBPACK FOOTER
// ../@csod/tracker-with-store/build/index.js
// module id = 379
// module chunks = 0